import { applyMiddleware, createStore } from "redux";
import filterMiddleware from "./middlewares/filterMiddleware";
import rootReducer from "./rootReducer";

const store = createStore(rootReducer, applyMiddleware(filterMiddleware))
export default store;